const SessionSalesCutoffEnum = require('@/lib/Sessions/SessionSalesCutoffEnum');
const { hmsStringToMilliseconds } = require('@/functions/date');
const { populate } = require('@/functions/objects');
const { toInt, toNullableString, toString } = require('@/functions/transform');

/**
 * This is a DigiTickets "Event" but is called "SessionEvent" to not be confused with JS's native "Event" class.
 *
 * @param {{}}data
 *
 * @constructor
 */
const SessionEvent = function (data = {}) {
    this.ID = null;
    this.name = '';
    this.navOrder = 10000;
    this.sessionType = '';
    this.staffSalesCutoffPointAfterSessionStart = SessionSalesCutoffEnum.SESSION_START; // Session Start is the default.
    this.staffSalesCutoffTime = null;

    /**
     * @type {number|null}
     */
    this.staffSalesCutoffTimeInMilliseconds = null;

    /**
     * @type {?string}
     */
    this.status = null;

    /**
     * @type {string|null}
     */
    this.imageUrl = null;

    this.ticketCats = [];

    /**
     * 80 is the default value for the yellowThreshold when a new event is created.
     *
     * @type {number}
     */
    this.yellowThreshold = 80;

    /**
     * 40 is the default value for the amberThreshold when a new event is created.
     *
     * @type {number}
     */
    this.amberThreshold = 40;

    /**
     * 0 is the default value for the redThreshold when a new event is created.
     *
     * @type {number}
     */
    this.redThreshold = 0;

    populate(this, data);
};

SessionEvent.prototype = {
    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'eventCatID'],
                transform: toInt,
            },
            imageUrl: toNullableString,
            name: {},
            navOrder: toInt,
            sessionType: {},
            staffSalesCutoffPointAfterSessionStart: {},
            staffSalesCutoffTime: {},
            status: toString,
            ticketCats: {},
            yellowThreshold: toInt,
            amberThreshold: toInt,
            redThreshold: toInt,
        };
    },

    /**
     * @return {number|null}
     */
    getStaffSalesCutoffTimeInMilliseconds() {
        if (this.staffSalesCutoffTime !== null && this.staffSalesCutoffTimeInMilliseconds === null) {
            // Recalculate the millisecond value if there should be one but there isn't.
            // We store this in a property because this is accessed lots of times, so avoiding recalculating it
            // every time it's needed is useful.
            this.staffSalesCutoffTimeInMilliseconds = hmsStringToMilliseconds(this.staffSalesCutoffTime);
        }

        return this.staffSalesCutoffTimeInMilliseconds;
    },
};

module.exports = SessionEvent;
